import styled from "styled-components";
export const ModalContainer = styled.div`
  position: fixed;
  z-index: 200;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .overlay {
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .body {
    background-color: #fff;
    border-radius: 10px;
    min-width: 300px;
    max-width: ${(props) => (props.size === "small" ? "480px" : "85%")};
    width: 100%;
    padding: 16px;
    position: relative;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    overflow-y: auto;
    max-height: 85vh;
    .modal-message {
      margin-bottom: 16px;
    }
    .modal-buttons {
      display: flex;
      justify-content: space-between;
    }
  }
`;
